import { useSelector } from '@legendapp/state/react';
import type { ComponentProps, ElementType } from 'react';
import { useHeroBlockSearchFormState } from '@/components/forms/HeroBlockSearchForm/HeroBlockSearchFormProvider';
import { cn } from '@/lib/cn';

export type HeroSearchFormColumnProps<T extends ElementType = 'div'> = ComponentProps<T> & {
    as?: T;
};

export function HeroSearchFormColumn<T extends ElementType = 'div'>({ as, children, className, ...props }: HeroSearchFormColumnProps<T>) {
    const variant = useSelector(useHeroBlockSearchFormState().variant$);
    const hasVariant = variant !== undefined;
    const isVertical = variant === 'vertical';

    const Tag = as || 'div';
    return (
        <Tag
            className={cn(
                'border-base-125 h-21 px-6 lg:px-4 xl:px-6 flex-col gap-0.75 justify-center text-left whitespace-nowrap',
                {
                    'lg:flex hidden': !hasVariant,
                    flex: hasVariant && !isVertical,
                    hidden: hasVariant && isVertical,
                },
                className
            )}
            {...props}
        >
            {children}
        </Tag>
    );
}
